import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';

import { RESERVATION_GUEST_TYPES } from '../../../utils/reservations';
import { addFlyout, FLYOUT_TYPES } from '../../../utils/flyout';

const onReservationClick = reservation => () => {
  addFlyout(FLYOUT_TYPES.RESERVATION_DETAILS, {
    reservationId: _.get(reservation, 'id'),
  });
};

class ReservationBar extends Component {
  constructor(props) {
    super(props);

    this.CLASS_NAME = 'brzw-calendar-reservation';
    this.CELL_DATE = props.cellDate.format('YYYY-MM-DD');

    this.setHoveredReservation = this.setHoveredReservation.bind(this);
  }

  componentDidMount() {
    const { setFirstIdOfReservation, type } = this.props;
    const id = _.get(this.props, [type, 'id']);

    if (id) setFirstIdOfReservation(id, this.CELL_DATE);
  }

  setHoveredReservation(id = 0) {
    return () => {
      this.props.setHoveredReservation(id);
    };
  }

  render() {
    const {
      alert,
      baseClassName,
      className,
      flyoutInformations,
      hoveredReservation,
      numberOfOccupied,
      reservation,
    } = this.props;
    const typeGuestCode = _.get(reservation, 'type_guest.code', '');
    const id = _.get(reservation, 'id');
    const highlight = _.get(flyoutInformations, 'reservationId') === id;

    const reservationClassName = classnames(className, {
      [`${baseClassName}--on-hold`]: typeGuestCode === RESERVATION_GUEST_TYPES.HOLD,
      [`${this.CLASS_NAME}--highlight`]: highlight,
      [`${this.CLASS_NAME}--hovered`]: hoveredReservation === id,
      [`${this.CLASS_NAME}--id-${id}`]: id,
      [`${this.CLASS_NAME}--with-alert`]: alert,
      [`${this.CLASS_NAME}__multiple-occupied`]: numberOfOccupied > 1,
    });

    if (reservation) {
      return (
        <button
          className={classnames(
            `${this.CLASS_NAME}__clickable-wrapper`,
            'brzw-button',
            reservationClassName,
          )}
          onBlur={this.setHoveredReservation(0)}
          onClick={onReservationClick(reservation)}
          onFocus={this.setHoveredReservation(id)}
          onMouseEnter={this.setHoveredReservation(id)}
          onMouseOut={this.setHoveredReservation(0)}
          type="button"
        />
      );
    }

    return <div className={reservationClassName} />;
  }
}

ReservationBar.propTypes = {
  alert: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({})]),
  baseClassName: PropTypes.string,
  cellDate: PropTypes.shape({
    format: PropTypes.func,
  }),
  checkin: PropTypes.shape({}),
  checkout: PropTypes.shape({}),
  className: PropTypes.string,
  flyoutInformations: PropTypes.shape({
    reservationId: PropTypes.number,
  }),
  hoveredReservation: PropTypes.number,
  numberOfOccupied: PropTypes.number,
  occupied: PropTypes.shape({}),
  reservation: PropTypes.shape({}),
  setFirstIdOfReservation: PropTypes.func,
  setHoveredReservation: PropTypes.func,
  type: PropTypes.string,
};

export default ReservationBar;
